import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../store/ApplicationState";
import { TabSessionDataDispatchTypes } from "../../../models/DispatchTypes/TabSessionStorage";
import DocumentUpload from "../components/DocumentUpload";
import { DeleteBlobId, UploadDocument } from "../../../actions/DocumentUpload";
import { resetStates } from "../../../actions/Common";

const mapStateToProps = ({ DocumentUploadState }: ApplicationState) => ({
  UploadedDocumentData: DocumentUploadState,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<
    ApplicationState,
    Record<string, never>,
    TabSessionDataDispatchTypes
  >
) => {
  return {
    UploadDocument: (file: any) => {
      dispatch(UploadDocument(file));
    },
    DeleteDocument: (blobId: number) => {
      dispatch(DeleteBlobId(blobId));
    },
    resetStates: (actionType: string[]) => {
      dispatch(resetStates(actionType));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentUpload);
